import { render, staticRenderFns } from "./workflow-center-menu.vue?vue&type=template&id=abf695c4&"
import script from "./workflow-center-menu.vue?vue&type=script&lang=ts&"
export * from "./workflow-center-menu.vue?vue&type=script&lang=ts&"
import style0 from "./workflow-center-menu.vue?vue&type=style&index=0&id=abf695c4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports